import {SourceLinkSettingsModel} from "../../settings/models/source-link-settings";
import {autoinject} from "aurelia-dependency-injection";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import Marionette from "../../shared/marionette-mustache";
import {ThinkerView} from "../../shared/views/thinker";
import { UserSettingsModel } from "../models/user-settings";

const template  = require<string>("../../settings/views/search-settings.html");

const dom  = {
    BACK_LINK: ".sourcelink-back-link",
    LOADING_REGION: "#search-settings-loading-region",
    CONTENT_REGION: "#search-settings-content-region",
    SUBSCRIPTION_ONLY: "#subscription-only",
    SAVE_ORG_SETTINGS: ".save-organisation-search-button",
};

@autoinject
@backboneViewProperties({
    template: template
})
export class SearchSettingsView  extends Marionette.LayoutView<UserSettingsModel> {

    private loadingRegion: Marionette.Region;

    constructor(public model: UserSettingsModel) {
        super();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.BACK_LINK] = (e) => this.backClick(e);
        events["click " + dom.SUBSCRIPTION_ONLY] = (e) => this.subscriptionOnlyClick(e);
        events["click " + dom.SAVE_ORG_SETTINGS] = (e) => this.saveOrganisationSettingsClick(e);
        return events;
    }

    public regions(): any {
        const regions: any = {
            loadingRegion: dom.LOADING_REGION
        };
        return regions;
    }

    public onShow() {
        this.setupLoader();
    }

    public renderSettings() {
        this.render();
        this.$(dom.CONTENT_REGION).show();
        this.updateSubscriptionOnlyCheckbox();
    }

    private setupLoader() {
        this.loadingRegion.show(new ThinkerView());
    }

    private backClick(e: JQueryEventObject) {
        const level = this.$(e.currentTarget).attr("data-level");
        const levelInt = parseInt(level, 10);
        const offset = (400 * (levelInt - 1)) + "px";
        const transformString = "transform: translateX(-" + offset + ")";
        this.$el.parent().attr("style", transformString);
    }

    private updateSubscriptionOnlyCheckbox() {
        this.$(dom.SUBSCRIPTION_ONLY).prop("checked", this.model.SubscriptionOnly);
    }

    private subscriptionOnlyClick(e: JQueryEventObject) {
        const $checkbox = $(e.currentTarget);
        const selected = $checkbox.prop("checked");
        this.model.SubscriptionOnly = selected;
        _.defer(() => {
            this.model.saveAndNotify();
        });
    }

    private saveOrganisationSettingsClick(e: JQueryEventObject) {
        this.model.saveOrganisationSettings();
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/views/search-settings.ts